module.exports = __webpack_public_path__ + "img/icon2-3.1bc56346.png";